import CircularPercentageBar from "./CircularPercentageBar";

export default CircularPercentageBar;
